import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { PublicCustomFieldsProvider } from "~/providers/PublicCustomFieldsProvider";
import { canSeeCustomFields } from "~/utils/permissions/workspacePermissions";
export const PublicBoardCustomFieldsProvider = /*#__PURE__*/ memo((props)=>{
    const { permissions } = usePublicPermissions();
    const canViewCustomFields = canSeeCustomFields(permissions);
    return /*#__PURE__*/ _jsx(PublicCustomFieldsProvider, {
        canViewCustomFields: canViewCustomFields,
        ...props
    });
});
PublicBoardCustomFieldsProvider.displayName = "PublicBoardCustomFieldsProvider";
